import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';
import { BusinessCreateBody } from './create';

export type BusinessUpdateData = {
  success: boolean;
};

export type BusinessUpdateResponse = BusinessUpdateData;

export type BusinessUpdateBody = Partial<BusinessCreateBody>

export interface BusinessUpdatePayload {
  id: string;
  body: BusinessUpdateBody
}

export const businessUpdate = (payload: BusinessUpdatePayload): Action<BusinessUpdatePayload> => ({
  type: actions.businessUpdateTrigger.toString(),
  payload,
});

export const businessUpdateClear = (): Action => ({
  type: actions.businessUpdateClear.toString(),
});

export const businessUpdateErrorClear = (): Action => ({
  type: actions.businessUpdateErrorReset.toString(),
});

export function* businessUpdateRequestSaga({ payload }: Action<BusinessUpdatePayload>) {
  yield put({
    type: actions.businessUpdateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.businessUpdateError.toString(),
      payload: {
        message: 'BusinessUpdate: Parameters not passed.',
      },
    });

    return;
  }

  const { id, body } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/businesses/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<BusinessUpdateData, BusinessUpdateResponse>(
    response,
    actions.businessUpdateSuccess.toString(),
    actions.businessUpdateError.toString(),
    false,
    (businessUpdateData) => businessUpdateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.businessUpdateTrigger.toString(),
    defaultProcessingSaga(
      businessUpdateRequestSaga,
      {
        error: actions.businessUpdateError.toString(),
        locationCancel: actions.businessUpdateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.businessUpdateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.businessUpdateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.businessUpdateErrorReset.toString(),
    });
  });
}
